<template>
  <ModalQRcode :is-visible="qrCodePopup.isVisible" @close="toggleQrcode()" />

  <nav
    v-if="visibleNavbar"
    v-bind="$attrs"
    :class="[backgroundStyle, 'fixed top-0 w-full z-10']"
  >
    <!-- Logo and Text on the left -->
    <div
      :class="[
        isMobile ? 'p-[16px]' : 'px-[32px] py-[16px]',
        'flex items-center justify-between h-full',
      ]"
    >
      <a href="/" to="/" class="flex items-center">
        <img
          src="../assets/images/go_logo.png"
          alt="Logo"
          class="logo-image w-[32px] h-[32px]"
        />
        <span :class="[logoText]" data-testid="navbar-logo-text">
          GO by Krungsri Auto
        </span>
      </a>

      <!-- Right Section -->
      <div class="flex items-center">
        <div v-if="isMobile" data-mdhidden="true" class="md:hidden">
          <button
            id="btn-download-goapp-guru"
            data-testid="mobile-download-bt"
            :class="[
              'cta-button',
              buttonStyle,
              'text-white rounded-lg focus:outline-none mr-[8px]',
            ]"
            @click="downloadAction()"
          >
            <span class="text-[#292828]">ดาวน์โหลด</span>
          </button>
        </div>

        <!-- Custom Navbar Toggle for mobile view with dynamic icon -->
        <button
          class="md:hidden"
          data-testid="custom-navbar-btn"
          @click="toggleNavbar"
        >
          <img
            :src="subMenuicon"
            data-testid="custom-navbar-img"
            alt="Menu Icon"
            class="w-[32px] h-[32px]"
            @mouseover="getMenuiconhover"
            @mousedown="getMenuiconhover"
            @mouseleave="getMenuicon"
          />
        </button>
      </div>

      <!-- Non-mobile version: Download button on the right -->
      <div
        v-if="!isMobile && visibleNavbar"
        class="flex items-center focus:outline-none"
      >
        <a
          href="/"
          to="/"
          data-testid="desktop-first-page"
          :class="['mr-[8px] p-[6px] rounded-[8px]', textColor]"
          >หน้าแรก</a
        >

        <!-- Desktop Lifestyle Dropdown -->
        <div
          v-if="!isMobile"
          ref="dropdownDiv"
          class="relative"
          data-testid="desktop-lifestyle"
          @mouseover="openDropdownOnHover"
          @mouseleave="isCloseHover"
          @click="toggleDropdown($event)"
        >
          <button
            :class="[
              'flex items-center mr-[8px] p-[6px] rounded-[8px] hover:bg-[#FFEE99] gap-[8px] group',
              textColor,
            ]"
          >
            <span data-testid="desktop-title-lifestyle">ไลฟ์สไตล์</span>
            <div
              class="border-[1px] group-hover:border-[0px] group-hover:bg-[#FFFFFF] h-[20px] w-[20px] rounded-[6px] flex justify-center items-center"
            >
              <Icon
                v-if="!isDropdownOpen"
                name="i-tabler:chevron-down"
                mode="svg"
                class="h-[18px] w-[18px] group-hover:hidden"
              />
              <Icon
                v-else
                name="i-tabler:chevron-up"
                mode="svg"
                class="h-[18px] w-[18px] group-hover:hidden"
              />
              <Icon
                v-if="!isDropdownOpen"
                name="i-tabler:chevron-down"
                class="h-[18px] w-[18px] hidden group-hover:block text-[#292828]"
                mode="svg"
              />
              <Icon
                v-else
                name="i-tabler:chevron-up"
                mode="svg"
                class="h-[18px] w-[18px] hidden group-hover:block text-[#292828]"
              />
            </div>
          </button>

          <div
            v-if="isDropdownOpen"
            class="absolute top-[24px] right-[-48px] min-w-[184px] group-hover:block space-y-2 bg-transparent rounded-lg w-32"
            @click.stop
          >
            <div
              class="flex flex-col mt-[30px] bg-white shadow-md rounded-[16px]"
            >
              <div class="w-full p-[8px]">
                <template v-for="submenu in listSubmenu" :key="submenu.title">
                  <NuxtLink
                    v-if="!submenu.isDisable"
                    :to="submenu.linkto"
                    external
                  >
                    <div
                      class="flex items-center h-[44px] w-full submenu-mobile"
                    >
                      <span
                        :class="[
                          ' pl-[8px] text-[#292828]',
                          { highlighted: isActiveSubmenu(submenu) },
                        ]"
                      >
                        {{ submenu.title }}
                      </span>
                    </div>
                  </NuxtLink>
                  <div
                    v-else
                    class="flex items-center h-[44px] w-full submenu-mobile"
                  >
                    <span class="pl-[8px] text-[#292828] disableSubMenu">
                      {{ submenu.title }}
                    </span>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>

        <a
          href="/frequently-asked-questions/"
          to="/frequently-asked-questions/"
          data-testid="desktop-frequently-asked-questions"
          :class="[
            'text-sm mr-[8px] p-[6px] rounded-[8px]',
            textColor,
            { highlighted: isActive('/frequently-asked-questions') },
          ]"
          >คำถามที่พบบ่อย</a
        >
        <a
          href="/about-us/"
          to="/about-us/"
          data-testid="desktop-about-us"
          :class="[
            'text-sm mr-[8px] p-[6px] rounded-[8px]',
            textColor,
            { highlighted: isActive('/about-us') },
          ]"
          >เกี่ยวกับเรา</a
        >
        <a
          href="/contact-us/"
          to="/contact-us/"
          data-testid="desktop-contact-us"
          :class="[
            'text-sm mr-[8px] p-[6px] rounded-[8px]',
            textColor,
            { highlighted: isActive('/contact-us') },
          ]"
          >ติดต่อเรา</a
        >
        <button
          id="btn-download-guru"
          class="cta-button rounded-lg focus:outline-none"
          data-testid="desktop-download-bt"
          @click="downloadAction()"
        >
          <span class="text-[#292828]">ดาวน์โหลด</span>
        </button>
      </div>
    </div>

    <!-- Collapsible Main Navbar Items -->
    <Transition name="slide">
      <div
        v-if="isNavbarCollapsed"
        id="dropdownMenu"
        class="absolute top-0 left-0 w-full md:hidden bg-white rounded-b-[14px] z-20"
      >
        <!-- Navbar Menu Header -->
        <div class="p-[16px] flex items-center justify-between h-full">
          <a href="/" to="/" class="flex items-center">
            <img
              src="../assets/images/go_logo.png"
              alt="Logo"
              class="logo-image w-[32px] h-[32px]"
            />
            <span class="logo-web-red-text" data-testid="navbar-logo-text">
              GO by Krungsri Auto
            </span>
          </a>
          <div class="flex items-center">
            <div v-if="isMobile" class="md:hidden">
              <button
                id="btn-download-goapp-guru"
                data-testid="mobile-download-bt"
                :class="[
                  'cta-button',
                  buttonStyle,
                  'text-white rounded-lg focus:outline-none mr-[8px]',
                ]"
                @click="downloadAction()"
              >
                <span class="text-[#292828]">ดาวน์โหลด</span>
              </button>
            </div>

            <button
              class="md:hidden toggle-close-icon"
              data-testid="toggle-close-icon"
              @click="toggleNavbar"
            ></button>
          </div>
        </div>

        <!-- Menu Items -->
        <div class="p-[16px]">
          <div
            v-if="isMobile && visibleNavbar"
            class="flex flex-col md:hidden text-sm"
          >
            <a
              href="/"
              to="/"
              class="pl-[8px] flex items-center mb-[8px] h-[44px] submenu-mobile text-web-red"
              data-testid="mobile-first-page"
            >
              หน้าแรก
            </a>

            <!-- "Lifestyle" item with submenu toggle button -->
            <div v-if="isMobile" class="flex flex-col items-start">
              <button
                class="flex items-center justify-between w-full mb-[8px] pl-[8px] pr-[8px] h-[44px] submenu-mobile"
                data-testid="mobile-lifestyle"
                @click.stop="toggleLifestyle"
              >
                <span class="text-web-red" data-testid="mobile-title-lifestyle">
                  ไลฟ์สไตล์
                </span>
                <div
                  class="icon-container bg-[#FFFFFF] h-[24px] w-[24px] rounded-[6px] flex justify-center items-center"
                >
                  <Icon
                    :name="
                      showLifestyle
                        ? 'i-tabler:chevron-up'
                        : 'i-tabler:chevron-down'
                    "
                    class="h-[18px] w-[18px]"
                    mode="svg"
                  />
                </div>
              </button>

              <!-- Submenu items shown only on mobile when 'showLifestyle' is true -->
              <div
                v-if="isMobile && showLifestyle"
                class="flex flex-col w-full"
              >
                <template v-for="submenu in listSubmenu" :key="submenu.title">
                  <NuxtLink
                    v-if="!submenu.isDisable"
                    data-testid="toggle-navbar-link"
                    :to="submenu.linkto"
                    external
                    @click="toggleNavbar()"
                  >
                    <div
                      class="flex items-center justify-start h-[44px] submenu-mobile mb-[8px]"
                    >
                      <span
                        :class="[
                          'pl-[32px] text-[#292828]',
                          { highlighted: isActiveSubmenu(submenu) },
                        ]"
                      >
                        {{ submenu.title }}
                      </span>
                    </div>
                  </NuxtLink>
                  <div
                    v-else
                    class="flex items-center justify-start h-[44px] submenu-mobile"
                  >
                    <span class="pl-[32px] text-[#292828] disableSubMenu">
                      {{ submenu.title }}
                    </span>
                  </div>
                </template>
              </div>
            </div>

            <a
              href="/frequently-asked-questions/"
              to="/frequently-asked-questions/"
              :class="[
                'pl-[8px] flex items-center mb-[8px] h-[44px] submenu-mobile text-web-red',
                { highlighted: isActive('/frequently-asked-questions') },
              ]"
              data-testid="mobile-frequently-asked-questions"
            >
              คำถามที่พบบ่อย
            </a>

            <a
              href="/about-us/"
              to="/about-us/"
              :class="[
                'pl-[8px] flex items-center mb-[8px] h-[44px] submenu-mobile text-web-red',
                { highlighted: isActive('/about-us') },
              ]"
              data-testid="mobile-about-us"
            >
              เกี่ยวกับเรา
            </a>

            <a
              href="/contact-us/"
              to="/contact-us/"
              :class="[
                'pl-[8px] flex items-center mb-[8px] h-[44px] submenu-mobile text-web-red',
                { highlighted: isActive('/contact-us') },
              ]"
              data-testid="mobile-contact-us"
            >
              ติดต่อเรา
            </a>
          </div>
        </div>
      </div>
    </Transition>
  </nav>

  <!-- For mobile: fullscreen overlay when navbar is collapsed -->
  <div
    v-if="isMobile && isNavbarCollapsed"
    class="fixed inset-0 bg-black/30 z-10"
  />
</template>

<script>
import "@/assets/css/shared-dropdown-animation.css";
import dropdownDarkIcon from "@/assets/images/dropdown_desktop_icon.svg";
import dropdownIcon from "@/assets/images/dropdown_desktop_icon_dark.svg";
import dropdownIconPressed from "@/assets/images/dropdown_desktop_icon_dark_pressed.svg";
import dropdownDarkIconPressed from "@/assets/images/dropdown_desktop_icon_pressed.svg";
import dropdownUPDarkIcon from "@/assets/images/dropdown_desktop_up_icon.svg";
import dropdownUPIcon from "@/assets/images/dropdown_desktop_up_icon_dark.svg";
import dropdownUPIconPressed from "@/assets/images/dropdown_desktop_up_icon_dark_pressed.svg";
import dropdownUPDarkIconPressed from "@/assets/images/dropdown_desktop_up_icon_pressed.svg";
import menuIcon from "@/assets/images/menu_button.svg";
import menuIconDark from "@/assets/images/menu_button_dark.svg";
import menuIconDarkPressed from "@/assets/images/menu_button_dark_pressed.svg";
import menuIconPressed from "@/assets/images/menu_button_pressed.svg";
import "@/assets/styles/navigation_bar.css";
import { qrCodePopup } from "@/composables/useQrcodePopup.ts";

export default {
  props: {
    background: {
      type: String,
      default: "light",
      validator: (value) => ["light", "dark"].includes(value),
    },
  },
  data() {
    return {
      listSubmenu: [
        {
          title: "Auto Club",
          linkto: "/auto-club/",
          activepath: ["/"],
          isDisable: false,
        },
      ],
      colorMode: this.background,
      showLifestyle: false,
      isNavbarCollapsed: false,
      isMobile: false,
      isHover: false,
      menuIcon,
      dropdownIcon,
      dropdownDarkIcon,
      dropdownUPIcon,
      dropdownUPDarkIcon,
      dropdownDarkIconPressed,
      dropdownIconPressed,
      dropdownUPDarkIconPressed,
      dropdownUPIconPressed,
      isDropdownOpen: false,
      isLargeScreen: window?.innerWidth >= 1024, // lg breakpoint
      subMenuicon: menuIconDark,
      dropdownMenuicon: dropdownIcon,
      visibleNavbar: false,
    };
  },
  computed: {
    logoText() {
      return this.colorMode === "dark"
        ? "logo-web-default-text"
        : "logo-web-red-text";
    },
    backgroundStyle() {
      return this.background === "dark" ? "main-nav-bar-red" : "main-nav-bar";
    },
    textColor() {
      return this.colorMode === "dark" ? "text-web-default" : "text-web-red";
    },
    buttonStyle() {
      return this.colorMode === "dark" ? "outline-light" : "primary";
    },
  },
  mounted() {
    this.checkMobile();
    this.getMenuicon();
    window.addEventListener("resize", this.checkMobile);
    this.visibleNavbar = true;
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.checkMobile);
  },
  methods: {
    toggleQrcode() {
      if (qrCodePopup.value.isVisible) {
        qrCodePopup.value.hideQrCode();
      } else {
        qrCodePopup.value.showQrCode();
      }
    },
    getDropdownIcon() {
      if (this.isDropdownOpen) {
        return this.colorMode === "dark"
          ? this.dropdownUPDarkIconPressed
          : this.dropdownUPIconPressed;
      }
      return this.colorMode === "dark"
        ? this.dropdownDarkIcon
        : this.dropdownIcon;
    },
    getMenuicon() {
      if (this.colorMode === "dark") {
        this.subMenuicon = menuIconDark;
      } else {
        this.subMenuicon = menuIcon;
      }
    },
    getMenuiconhover() {
      if (this.colorMode === "dark") {
        this.subMenuicon = menuIconDarkPressed;
      } else {
        this.subMenuicon = menuIconPressed;
      }
    },
    checkDynamicPath() {
      const route = useRoute();

      if (route.params.contentid) {
        return true;
      }

      return false;
    },
    isActiveSubmenu(submenu) {
      const route = useRoute();
      console.log(route.path);
      const isDirectMatch = submenu.activepath.includes(route.path);
      const isDynamicPath =
        this.checkDynamicPath() && submenu.title === "Auto Club";

      return isDirectMatch || isDynamicPath;
    },
    isActive(path) {
      const route = useRoute();
      return route.path === path;
    },
    toggleColorMode() {
      this.colorMode = this.colorMode === "dark" ? "light" : "dark";
      this.getMenuicon();
    },
    toggleLifestyle() {
      this.showLifestyle = !this.showLifestyle;
    },
    toggleNavbar() {
      this.isNavbarCollapsed = !this.isNavbarCollapsed;
      if (this.isNavbarCollapsed == true) {
        this.colorMode = "light";
        this.toggleBodyScroll(true);
      } else {
        this.showLifestyle = false;
        if (this.background == "dark") {
          this.colorMode = "dark";
        }
        this.toggleBodyScroll(false);
      }
      this.getMenuicon();
    },
    checkDeviceType() {
      if (!useDevice().isDesktopOrTablet) {
        return false;
      }
      return true;
    },
    isCloseHover() {
      this.isHover = false;
      this.closeDropdownOnHover();
    },
    toggleDropdown(event) {
      event.stopPropagation();
      if (!this.isDropdownOpen) {
        this.isDropdownOpen = true;
        document.addEventListener("click", this.handleOutsideClick);
      } else {
        this.isDropdownOpen = false;
        document.removeEventListener("click", this.handleOutsideClick);
      }
    },
    closeDropdown() {
      this.isDropdownOpen = false; // Close dropdown on mouse leave
    },
    openDropdownOnHover() {
      if (this.checkDeviceType()) {
        this.isDropdownOpen = true;
      }
    },
    closeDropdownOnHover() {
      this.isDropdownOpen = false;
    },
    checkMobile() {
      this.isMobile = window.innerWidth < 768; // Bootstrap 'lg' breakpoint
      this.handleResizeNavbarColor();
    },
    handleResizeNavbarColor() {
      if (this.isMobile === false) {
        if (this.background == "dark") {
          this.colorMode = "dark";
        }
      }
    },
    handleOutsideClick(event) {
      if (!this.$refs.dropdownDiv?.contains(event.target)) {
        this.closeDropdown();
        document.removeEventListener("click", this.handleOutsideClick); // Clean up
      }
    },
    beforeDestroy() {
      document.removeEventListener("click", this.handleOutsideClick);
    },
    openSuperRoute() {
      // TODO Move to util
      const route = useRoute();
      const url = new SuperRouteUtil().getSuperRoute(route.params);
      window.open(url, "_blank");
      window.location.assign(import.meta.env.VITE_SUPERROUTE_BASE_URL);
    },
    downloadAction() {
      if (this.isMobile) {
        this.openSuperRoute();
      } else {
        this.toggleQrcode();
      }
    },
    toggleBodyScroll(isDisabled) {
      document.body.classList.toggle("overflow-hidden", isDisabled);
    },
  },
};
</script>
